import * as React from "react";

const TimeIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
    >
        <g clipPath="url(#clip0_855_20854)">
            <mask
                id="mask0_855_20854"
                width="16"
                height="17"
                x="0"
                y="-1"
                maskUnits="userSpaceOnUse"
                style={{ maskType: "luminance" }}
            >
                <path fill="#fff" d="M0 0h16v16H0z"></path>
            </mask>
            <g
                stroke="#686A71"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                mask="url(#mask0_855_20854)"
            >
                <path d="M11.816 14.328a7.375 7.375 0 1 1 3.56-6.312 7.35 7.35 0 0 1-1.251 4.093"></path>
                <path d="M8 5.093v2.922L4.781 4.687M8.031.906v.969M8.031 14.093v.969M.969 7.968h.969M14.156 7.968h.969"></path>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_855_20854">
                <path fill="#fff" d="M0 0h16v16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export default TimeIcon;
